            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">       
      <b-row style="width:100%">
        <b-col sm="12">
          <b-row  class="row-inputs">
            <p>Aquí se anulara el registro de aporte y el archivo plano de los siguientes afiliados generados en el sistema.</p>  
            <br>
            <b-col :md="12" :lg="12">
               <validation-provider  rules="required" immediate  v-slot="{ errors, required }"
                name="nota_delete"> 
                <b-form-group
                    v-bind:class="{'is-invalid': veevalidateInputs(errors[0],'required',nota_delete)}"
                    label="Nota"
                    :state="veevalidateInputs(errors[0],'required',nota_delete)"
                  >
                  <b-form-input id="input-1" v-model="nota_delete" ></b-form-input>
                  <small  class="text-danger input-errors-table" style="bottom: 10px;top: inherit;">{{errors[0]}}</small>
                </b-form-group> 
                </validation-provider>
            </b-col> 
            <b-col v-if="dataForm[namePath].info_aportes.servicios<2">
              <h5>Lista de afiliados</h5>
                    <table  style="margin-bottom:0" class="table table--get table-hover border box-effect linear">
                      <thead>
                        <tr>
                          <th>Documento</th>
                          <th>Nombres</th>
                          <th>Razón</th>
                          <th>Servicios</th>
                          <th>Valor</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(items,index) in dataAportes" :key="'listadoAportes'+index">
                          <td>{{gettersDatalist('datos_afiliado',items.aportes_registro.id_datos_afiliado)[0].documento}}</td>
                          <td>{{gettersDatalist('datos_afiliado',items.aportes_registro.id_datos_afiliado)[0].name}}</td>
                          <td>{{gettersDatalist('datos_razon',items.aportes_registro.id_datos_razon)[0].name}}</td>
                          <td>{{nameServicios(items.aportes_registro.servicios)}}</td>
                          <td>{{items.aportes_registro.valor}}</td>
                        </tr>
                      </tbody>
                    </table> 
            </b-col>         
          </b-row>
        </b-col>
      </b-row>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 10px -15px 0">
        <b-row style="padding-top: 10px;">
          <b-col class="text-right" v-if="dataForm[namePath].info_aportes.servicios<2">             
              <b-button  @click="save(false)" 
                :disabled="dataAportes.length===0 || invalid"
                variant="success" 
                size="sm" 
                class="ml-2" 
                v-ripple="'rgba(255, 255, 255, 0.10)'" 
              >Anular
              </b-button>
          </b-col>
          <b-col class="text-right" v-else>             
              <b-button  @click="save(false)" 
                :disabled="invalid"
                variant="success" 
                size="sm" 
                class="ml-2" 
                v-ripple="'rgba(255, 255, 255, 0.10)'" 
              >Anular
              </b-button>
          </b-col>
        </b-row> 
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState, mapActions } from "vuex"
import SwInputs  from '@/components/forms/inputs.vue'
import { ValidationObserver } from 'vee-validate'
import { ValidationProvider } from 'vee-validate'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    nameInactive: {
      type: String,
      default: ''
    }
  },
  data()
  {
    return {
      nameAfiliado:'',
      dataAportes: [],
      nota_delete: null
    }
  },
  computed: {    
    ...mapState({
    })
  },
  async created()
  {
    await this.updateDataForm({data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]]})

    if(this.dataForm[this.namePath].info_aportes.servicios<2)
    {
      this.dataAportes = await this.getData({route: 'get_aportesregistro', data: this.dataForm[this.namePath].info_aportes.id})
    }

    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  async destroyed(){
    await this.resetDataForm()
  },
  methods: {
    nameServicios(value){ 
      let name=''
      value=JSON.parse(value)
      for(let i=0;i<value.length;i++)
      {        
        name=name+' '+value[i].name
        if(value[i].name_list!==null && value[i].name_list!=='')
        {
          name=name+' '+this.gettersDatalist(value[i].name_list,value[i].id_list)[0].name+' '
        }
      } 
      return name
    },
    async save(emit)
    {
      try{
        await this.updateDataForm({state:'info_aportes/anulado', data: 1})
        await this.updateDataForm({state:'info_aportes/nota_delete', data: this.nota_delete})
        let newDataPost=[]
        if(this.dataForm[this.namePath].info_aportes.servicios<2)
        {
          for (let i = 0; i < this.dataAportes.length; i++) {
            
            newDataPost[i]={}
            newDataPost[i].archivo_plano={}
            newDataPost[i].aportes_registro={}        
            if(this.dataForm[this.namePath].info_aportes.tipo===0)
            {
              newDataPost[i].info_aportes=this.dataForm[this.namePath].info_aportes
            }          

            newDataPost[i].archivo_plano.id=this.dataAportes[i].archivo_plano.id
            newDataPost[i].archivo_plano.nota_delete=this.nota_delete

            newDataPost[i].aportes_registro.id=this.dataAportes[i].aportes_registro.id
            newDataPost[i].aportes_registro.nota_delete=this.nota_delete

            if(this.dataForm[this.namePath].info_aportes.fecha!==null)
            {
              newDataPost[i].info_afiliacion={}  
              newDataPost[i].info_afiliacion.id=this.dataAportes[i].info_afiliacion.id
              newDataPost[i].info_afiliacion.dias=this.dataAportes[i].archivo_plano.dias
              newDataPost[i].info_afiliacion.mes_periodo=parseInt(this.dataAportes[i].archivo_plano.id_list_mes)
              newDataPost[i].info_afiliacion.ano_periodo=parseInt(this.dataAportes[i].archivo_plano.id_list_ano)
              newDataPost[i].info_afiliacion.id_list_novedad=this.dataAportes[i].archivo_plano.id_list_novedad
              newDataPost[i].servicios_activos=JSON.parse(this.dataAportes[i].aportes_registro.servicios)
            }     
            else 
            {
                this.dataForm[this.namePath].info_aportes.fecha=this.fecha().fecha.minHoy
            }                 
          }
          if(this.dataForm[this.namePath].info_aportes.tipo===1)
          {
            newDataPost.splice(0,0,{info_aportes: this.dataForm[this.namePath].info_aportes})
          } 
        }
        else 
        {             
          if(this.dataForm[this.namePath].info_aportes.fecha===null) 
          {
              this.dataForm[this.namePath].info_aportes.fecha=this.fecha().fecha.minHoy
          } 
          newDataPost.splice(0,0,{info_aportes: this.dataForm[this.namePath].info_aportes}) 
        }           
        
        await this.updateDataPost({state: 'data', data: newDataPost}) 

        this.$emit('save', {save: false, ftn: 'anularRegistroFtn'})
      }catch(e)
      {
        console.log(e)
      }
    },
    veevalidateInputs(rules,validate,value='')
      {
        if(validate!=='') 
        {
          if(['', null, undefined].indexOf(rules) === -1)
          {
            return false
          }
          return null
        }
        return null
      },
  }
}
</script>
<style>
  .form-group.is-invalid .form-control {
    border-color: #dc3545;
  }  
</style>